function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.154 5.396a4.066 4.066 0 010-2.219c.43-1.53 1.684-2.644 3.181-3.03a4.689 4.689 0 012.33 0c1.607.41 2.775 1.602 3.18 3.03.199.704.212 1.464 0 2.22l-3.303 11.746h-2.084L11.154 5.396zm-.152 20.318c0-2.367 2.015-4.285 4.5-4.285 2.483 0 4.498 1.918 4.498 4.285S17.985 30 15.502 30c-2.485 0-4.5-1.92-4.5-4.286z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "11",
  y: "0",
  width: "9",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.154 5.396a4.066 4.066 0 010-2.219c.43-1.53 1.684-2.644 3.181-3.03a4.689 4.689 0 012.33 0c1.607.41 2.775 1.602 3.18 3.03.199.704.212 1.464 0 2.22l-3.303 11.746h-2.084L11.154 5.396zm-.152 20.318c0-2.367 2.015-4.285 4.5-4.285 2.483 0 4.498 1.918 4.498 4.285S17.985 30 15.502 30c-2.485 0-4.5-1.92-4.5-4.286z",
  fill: "currentColor"
}))));